import { CommandManager } from '../core/commands/CommandManager';
import { EventBus } from '../core/events/IEventBus';
import { getNodeMutationManager } from '../core/commands/mutations/NodeMutationManager';

// Singleton instance for the application's command manager
let globalCommandManager: CommandManager | null = null;

export function getCommandManager(): CommandManager {
  if (!globalCommandManager) {
    const eventBus = new EventBus();
    globalCommandManager = new CommandManager(eventBus);
    // Register globally for E2E test access (mirrors __nodeMutationManager pattern)
    (window as any).__commandManager = globalCommandManager;
    // Warm the mutation manager so window.__nodeMutationManager exists before
    // the first command runs — external drivers probe for it at page load.
    try {
      getNodeMutationManager();
    } catch { }
  }
  return globalCommandManager;
}

export function useCommandManager(): CommandManager {
  return getCommandManager();
}